import SVG from "../Assests/SVG";
import { Info } from "@mui/icons-material";
import { RouteType } from "./Routesconfig";
import Screen from "./Layout/Screen";
import { AppRoutes } from "./Layout/Routes";

const AgricultureAppRoutes: RouteType[] = [
  {
    path: AppRoutes.AGRIDASHBOARD,
    state: "AgricultureDashboard",
    element: <Screen.AgricultureDashboard />,
    sidebarProps: {
      displayText: "global.Dashboard",
      icon: <SVG.Dashboard />,
    },
    role: "SUPER_ADMIN",
    routeName: "AGRICULTURE",
    child: [
      {
        path: AppRoutes.AGRIDASHBOARDGROWTHMONITORING,
        element: <Screen.GrowthMonitoringDetection />,
        state: "AgriGrowthMonitoring",
        sidebarProps: {
          displayText: "global.GrowthMonitoring",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "AGRICULTURE",
      },
      {
        path: AppRoutes.AGRIDASHBOARDANOMALYDETECTION,
        element: <Screen.AnomalyDetection />,
        state: "AgriAnomalyDetection",
        sidebarProps: {
          displayText: "global.AnomalyDetection",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "AGRICULTURE",
      },

      {
        path: AppRoutes.AGRIDASHBOARDPESTDETECTION,
        element: <Screen.PestDetection />,
        state: "AgriPetsDetection",
        sidebarProps: {
          displayText: "global.PestDetection",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "AGRICULTURE",
      },
      {
        path: AppRoutes.AGRIDASHBOARDDISEASEDETECTION,
        element: <Screen.DiseaseDetection />,
        state: "AgriDeceaseDetection",
        sidebarProps: {
          displayText: "global.DiseaseDetection",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "AGRICULTURE",
      },
    ],
  },
  {
    path: AppRoutes.AGRIREPORT,
    state: "AgricultureReportSummary",
    element: <Screen.AgriDashboardLayout />,
    sidebarProps: {
      displayText: "global.ReportSummary",
      icon: <SVG.ReportSummary />,
    },
    role: "SUPER_ADMIN",
    routeName: "AGRICULTURE",
    child: [
      {
        path: AppRoutes.AGRIREPORTGROWTHMONITORING,
        element: <Screen.AgriReportSummary />,
        state: "AgriGrowthMonitoring",
        sidebarProps: {
          displayText: "global.GrowthMonitoring",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "AGRICULTURE",
      },

      {
        path: AppRoutes.AGRIREPORTANOMALYDETECTION,
        element: <Screen.AgriReportSummary />,
        state: "AgriAnomalyDetection",
        sidebarProps: {
          displayText: "global.AnomalyDetection",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "AGRICULTURE",
      },

      {
        path: AppRoutes.AGRIREPORTPESTDETECTION,
        element: <Screen.AgriReportSummary />,
        state: "AgriPestDetection",
        sidebarProps: {
          displayText: "global.PestDetection",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "AGRICULTURE",
      },

      {
        path: AppRoutes.AGRIREPORTDISEASEDETECTION,
        element: <Screen.AgriReportSummary />,
        state: "AgridiseasesDetection",
        sidebarProps: {
          displayText: "global.DiseaseDetection",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "AGRICULTURE",
      },
    ],
  },
  {
    path: AppRoutes.AGRIMAINTENANCE,
    state: "AgriculturePredictiveMaintenance",
    element: <Screen.AgriDashboardLayout />,
    sidebarProps: {
      displayText: "global.PredictiveMaintenance",
      icon: <SVG.PredictiveMaintenance />,
    },
    role: "SUPER_ADMIN",
    routeName: "AGRICULTURE",
    child: [
      {
        path: AppRoutes.AGRIMAINTENANCEGROWTHMONITORING,
        element: <Screen.AgriDashboardLayout />,
        state: "AgriGrowthMonitoring",
        sidebarProps: {
          displayText: "global.GrowthMonitoring",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "AGRICULTURE",
      },

      {
        path: AppRoutes.AGRIMAINTENANCESERVICESCHEDULETIMELINE,
        element: <Screen.AgriDashboardLayout />,
        state: "ServiceScheduleTimeline",
        sidebarProps: {
          displayText: "global.ServiceScheduleTimeline",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "AGRICULTURE",
      },
    ],
  },
  {
    path: AppRoutes.AGRISUBSCRIBEFEATURES,
    state: "AgriSubscribe",
    element: <Screen.AgriDashboardLayout />,
    sidebarProps: {
      displayText: "global.SubscribeFeatures",
      icon: <SVG.Subscribe />,
    },
    role: "SUPER_ADMIN",
    routeName: "AGRICULTURE",
    child: [
      {
        path: AppRoutes.AGRISUBSCRIBEFEATUREADDDEVICE,
        element: <Screen.AgriDashboardLayout />,
        state: "AgriAddDevice",
        sidebarProps: {
          displayText: "global.AddMultipleDevice",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "AGRICULTURE",
      },

      {
        path: AppRoutes.AGRISUBSCRIBEIMPACTANALYSIS,
        element: <Screen.AgriDashboardLayout />,
        state: "AgriImpactAnalysis",
        sidebarProps: {
          displayText: "global.ImpactAnalysis",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "AGRICULTURE",
      },
      
    ],
  },
];

export default AgricultureAppRoutes;
